import { useEffect, useState, useRef } from "react";
import { Layout, Button, Modal, Popover } from "antd";
import { PauseOutlined } from "@ant-design/icons";
import { useParams } from "react-router-dom";
import "./Management.scss";
import NavBar from "../navbar/NavBar";
import SideBar from "../sider/SideBar";
import Map from "../map/Map";
import PopoverTitle from "../common/PopoverTitle";
import clsx from "clsx";
import CollaringVideo from "../../assets/videos/Collaring.mp4";
import VencesAssigning from "../tutorials/VencesAssigning/VencesAssigning";
import HerdWith10Icon from "../../assets/images/HerdWith10Icon.svg";
import ReactGA from "react-ga4";

const { Header, Sider, Content } = Layout;

function Management() {
  const [collapsed, setCollapsed] = useState(false);
  const [landmark, setLandmark] = useState({});
  const [currentTutorial, setCurrentTutorial] = useState("");
  const [currentTutorialId, setCurrentTutorialId] = useState("");
  const [currentStep, setCurrentStep] = useState(1);
  const [currentStepDetails, setCurrentStepDetails] = useState({});
  const params = useParams();
  const [startTimeOfTutorial, setStartTimeOfTutorial] = useState(null);

  // Landmark setting up tutorial
  const [landmarkSettingUpTutorialModal, setLandmarkSettingUpTutorialModal] =
    useState(false);
  const [landmarkStep2Modal, setLandmarkStep2Modal] = useState(false);
  const [landmarkStep5Modal, setLandmarkStep5Modal] = useState(false);
  const [landmarkStep8Modal, setLandmarkStep8Modal] = useState(false);
  const [landmarkStep11Modal, setLandmarkStep11Modal] = useState(false);
  const [landmarkStep13Modal, setLandmarkStep13Modal] = useState(false);
  const [landmarkStep15Modal, setLandmarkStep15Modal] = useState(false);

  // Herd setting up tutorial
  const [herdStep1Modal, setHerdStep1Modal] = useState(false);
  const [herdStep2Modal, setHerdStep2Modal] = useState(false);
  const [showPlayVideoButton, setShowPlayVideoButton] = useState(true);
  const [herdStep3Modal, setHerdStep3Modal] = useState(false);
  const [herdStep6Modal, setHerdStep6Modal] = useState(false);
  const [herdStep8Modal, setHerdStep8Modal] = useState(false);
  const [herdStep11Modal, setHerdStep11Modal] = useState(false);
  const [herdStep12Modal, setHerdStep12Modal] = useState(false);
  const videoRef = useRef();
  const [herdMarkerDetails, setHerdMarkerDetails] = useState({});

  // Creating vences tutorial
  const [venceStep1Modal, setVenceStep1Modal] = useState(false);
  const [venceStep4Modal, setVenceStep4Modal] = useState(false);
  const [venceInclusionDetails, setVenceInclusionDetails] = useState({});
  const [venceStep9Modal, setVenceStep9Modal] = useState(false);
  const [venceStep12Modal, setVenceStep12Modal] = useState(false);
  const [venceExclusionDetails, setVenceExclusionDetails] = useState({});
  const [venceStep15Modal, setVenceStep15Modal] = useState(false);

  // Assigning vences tutorial
  const [venceAssignStep1Modal, setVenceAssignStep1Modal] = useState(false);
  const [venceAssignStep2Modal, setVenceAssignStep2Modal] = useState(false);
  const [venceAssignStep3Modal, setVenceAssignStep3Modal] = useState(false);
  const [assignVenceToHerdModal, setAssignVenceToHerdModal] = useState(false);
  const [venceAssignStep22Modal, setVenceAssignStep22Modal] = useState(false);
  const [venceAssignStep23Modal, setVenceAssignStep23Modal] = useState(false);

  const tutorialsDetails = {
    LANDMARKS_SETTING_UP: {
      1: {
        step: 1,
        nextStep: 2,
        overlayElementsId: [],
        popoverComponents: [],
        modalComponents: ["landmarkSettingUpTutorialModal"],
        shouldShowOverlayMask: false,
        sideMenu: "Main",
      },
      2: {
        step: 2,
        overlayElementsId: ["map-container"],
        popoverComponents: [],
        modalComponents: ["landmarkStep2Modal"],
        shouldShowOverlayMask: true,
        sideMenu: "Main",
      },
      3: {
        step: 3,
        overlayElementsId: ["create-landmark-button"],
        popoverComponents: ["createLandmarkPopoverVisible"],
        modalComponents: [],
        shouldShowOverlayMask: true,
        sideMenu: "Main",
      },
      4: {
        step: 4,
        overlayElementsId: ["create-landmark-fence"],
        popoverComponents: ["landmarkStep4Popover"],
        modalComponents: [],
        shouldShowOverlayMask: true,
        sideMenu: "CreateLandmark",
        clearMarkers: ["fencePolygon"],
      },
      5: {
        step: 5,
        overlayElementsId: [],
        popoverComponents: [],
        modalComponents: ["landmarkStep5Modal"],
        shouldShowOverlayMask: false,
        sideMenu: "CreateLandmarkConfirm",
        drawingMode: "polygon",
        mapMarkers: ["fencePolygon"],
        clearMarkers: ["fencePolygon"],
        landmark: "Fence",
      },
      6: {
        step: 6,
        overlayElementsId: [],
        popoverComponents: [],
        modalComponents: ["landmarkStep5Modal"],
        shouldShowOverlayMask: false,
        sideMenu: "CreateLandmarkConfirm",
        drawingMode: "polygon",
        mapMarkers: ["fencePolygon"],
        clearMarkers: ["fencePolygon"], // clear marker before starting new.
        landmark: "Fence",
      },
      7: {
        step: 7,
        overlayElementsId: [],
        popoverComponents: ["landmarkStep7Popover"],
        modalComponents: ["modalNewLandmarkVisible"],
        shouldShowOverlayMask: false,
        sideMenu: "CreateLandmarkConfirm",
        mapMarkers: ["fencePolygon"],
        landmark: "Fence",
      },
      8: {
        step: 8,
        overlayElementsId: ["map-container"],
        popoverComponents: [],
        modalComponents: ["landmarkStep8Modal"],
        shouldShowOverlayMask: true,
        sideMenu: "Main",
        mapMarkers: ["fencePolygon"],
      },
      9: {
        step: 9,
        overlayElementsId: ["create-landmark-button"],
        popoverComponents: ["createLandmarkPopoverVisible"],
        modalComponents: [],
        shouldShowOverlayMask: true,
        sideMenu: "Main",
        mapMarkers: ["fencePolygon"],
      },
      10: {
        step: 10,
        overlayElementsId: ["create-landmark-gateway"],
        popoverComponents: ["landmarkStep10Popover"],
        modalComponents: [],
        shouldShowOverlayMask: true,
        sideMenu: "CreateLandmark",
        mapMarkers: ["fencePolygon"],
      },
      11: {
        step: 11,
        overlayElementsId: [],
        popoverComponents: [],
        modalComponents: ["landmarkStep11Modal"],
        shouldShowOverlayMask: false,
        sideMenu: "CreateLandmarkConfirm",
        landmark: "Gateway",
        mapMarkers: ["fencePolygon", "gatewayMarker"],
      },
      12: {
        step: 12,
        overlayElementsId: [],
        popoverComponents: ["landmarkStep7Popover"],
        modalComponents: ["modalNewLandmarkVisible"],
        shouldShowOverlayMask: false,
        sideMenu: "CreateLandmarkConfirm",
        mapMarkers: ["fencePolygon", "gatewayMarker"],
        landmark: "Gateway",
      },
      13: {
        step: 13,
        overlayElementsId: ["map-container"],
        popoverComponents: [],
        modalComponents: ["landmarkStep13Modal"],
        shouldShowOverlayMask: true,
        sideMenu: "Main",
        scrollTo: "Top",
        mapMarkers: ["fencePolygon", "gatewayMarker"],
      },
      14: {
        step: 14,
        overlayElementsId: ["import-kml-button"],
        popoverComponents: ["landmarkStep14Popover"],
        modalComponents: [],
        shouldShowOverlayMask: true,
        sideMenu: "Main",
        scrollTo: "Bottom",
        mapMarkers: ["fencePolygon", "gatewayMarker"],
      },
      15: {
        step: 15,
        overlayElementsId: [],
        popoverComponents: [],
        modalComponents: ["landmarkStep15Modal"],
        shouldShowOverlayMask: false,
        sideMenu: "Main",
        scrollTo: "Top",
        mapMarkers: ["fencePolygon", "gatewayMarker"],
        finalStep: true,
      },
    },
    HERDS_SETTING_UP: {
      1: {
        step: 1,
        overlayElementsId: [],
        popoverComponents: [],
        modalComponents: ["herdStep1Modal"],
        shouldShowOverlayMask: false,
        sideMenu: "Main",
        mapMarkers: [],
      },
      2: {
        step: 2,
        overlayElementsId: [],
        popoverComponents: [],
        modalComponents: ["herdStep2Modal"],
        shouldShowOverlayMask: false,
        sideMenu: "Main",
        mapMarkers: [],
      },
      3: {
        step: 3,
        overlayElementsId: ["map-container"],
        popoverComponents: [],
        modalComponents: ["herdStep3Modal"],
        shouldShowOverlayMask: true,
        sideMenu: "Main",
        mapMarkers: ["animalsWithCollar"],
      },
      4: {
        step: 4,
        overlayElementsId: ["create-herd-inventory-button"],
        popoverComponents: ["herdStep4Popover"],
        modalComponents: [],
        shouldShowOverlayMask: true,
        sideMenu: "Main",
        mapMarkers: ["animalsWithCollar"],
      },
      5: {
        step: 5,
        overlayElementsId: ["select-collars-on-map-button"],
        popoverComponents: ["herdStep5Popover"],
        modalComponents: [],
        shouldShowOverlayMask: true,
        sideMenu: "CreateHerd",
        mapMarkers: ["animalsWithCollar"],
        clearMarkers: ["createHerdRectangle"],
      },
      6: {
        step: 6,
        overlayElementsId: ["map-container", "create-herd-button"],
        popoverComponents: [],
        modalComponents: ["herdStep6Modal"],
        shouldShowOverlayMask: true,
        sideMenu: "CreateHerd",
        mapMarkers: ["animalsWithCollar", "createHerdRectangle"],
        drawingMode: "rectangle",
        clearMarkers: ["createHerdRectangle"],
      },
      7: {
        step: 7,
        overlayElementsId: [],
        popoverComponents: [],
        modalComponents: ["createHerdModal"],
        shouldShowOverlayMask: false,
        sideMenu: "CreateHerd",
        mapMarkers: ["animalsWithCollar", "createHerdRectangle"],
      },
      8: {
        step: 8,
        overlayElementsId: ["map-container"],
        popoverComponents: [],
        modalComponents: ["herdStep8Modal"],
        shouldShowOverlayMask: true,
        sideMenu: "HerdsToDisplay",
        mapMarkers: ["herdMarker"],
      },
      9: {
        step: 9,
        overlayElementsId: [],
        popoverComponents: ["herdStep9Popover"],
        modalComponents: [],
        shouldShowOverlayMask: false,
        sideMenu: "HerdsToDisplay",
        mapMarkers: ["herdMarker"],
      },
      10: {
        step: 10,
        overlayElementsId: ["collar-img"],
        popoverComponents: ["herdStep10Popover"],
        modalComponents: [],
        shouldShowOverlayMask: true,
        sideMenu: "HerdsToDisplay",
        mapMarkers: ["herdMarker"],
      },
      11: {
        step: 11,
        overlayElementsId: ["map-container"],
        popoverComponents: [],
        modalComponents: ["herdStep11Modal"],
        shouldShowOverlayMask: true,
        sideMenu: "HerdsToDisplay",
        mapMarkers: ["animalsWithIcon"],
      },
      12: {
        step: 12,
        overlayElementsId: [],
        popoverComponents: [],
        modalComponents: ["herdStep12Modal"],
        shouldShowOverlayMask: false,
        sideMenu: "HerdsToDisplay",
        mapMarkers: ["animalsWithIcon"],
        finalStep: true,
      },
    },
    VENCES_CREATING: {
      1: {
        step: 1,
        overlayElementsId: [],
        popoverComponents: [],
        modalComponents: ["venceStep1Modal"],
        shouldShowOverlayMask: false,
        sideMenu: "Main",
        mapMarkers: [],
      },
      2: {
        step: 2,
        overlayElementsId: ["create-vence-button"],
        popoverComponents: ["venceStep2Popover"],
        modalComponents: [],
        shouldShowOverlayMask: true,
        sideMenu: "Main",
        mapMarkers: [],
      },
      3: {
        step: 3,
        overlayElementsId: ["inclusion-vence-button"],
        popoverComponents: ["venceStep3Popover"],
        modalComponents: [],
        shouldShowOverlayMask: true,
        sideMenu: "CreateVence",
        mapMarkers: [],
        clearMarkers: ["venceInclusionPolygon"],
      },
      4: {
        step: 4,
        overlayElementsId: ["map-container"],
        popoverComponents: [],
        modalComponents: ["venceStep4Modal"],
        shouldShowOverlayMask: true,
        sideMenu: "CreateVenceConfirm",
        mapMarkers: ["venceStep4HighlightedArea"],
        drawingMode: "polygon",
        clearMarkers: ["venceInclusionPolygon"],
      },
      5: {
        step: 5,
        overlayElementsId: [],
        popoverComponents: ["venceStep6Popover"],
        modalComponents: [],
        clearSameModalComponents: ["createVenceModal"],
        shouldShowOverlayMask: false,
        sideMenu: "CreateVenceConfirm",
        mapMarkers: [
          "venceInclusionPolygon",
          "venceStep4HighlightedArea",
        ],
        clearMarkers: [],
        editableMarkers: ["venceInclusionPolygon"],
      },
      6: {
        step: 6,
        overlayElementsId: [],
        popoverComponents: ["venceStep7Popover"],
        modalComponents: [],
        sameModalComponents: ["createVenceModal"],
        shouldShowOverlayMask: false,
        sideMenu: "CreateVenceConfirm",
        mapMarkers: ["venceInclusionPolygon"],
      },
      7: {
        step: 7,
        overlayElementsId: [],
        popoverComponents: ["venceStep8Popover"],
        modalComponents: [],
        sameModalComponents: ["createVenceModal"],
        shouldShowOverlayMask: false,
        sideMenu: "CreateVenceConfirm",
        mapMarkers: ["venceInclusionPolygon"],
        clearMarkers: ["venceInclusionRedZonePolygon"],
      },
      8: {
        step: 8,
        overlayElementsId: ["map-container"],
        popoverComponents: [],
        modalComponents: ["venceStep9Modal"],
        clearSameModalComponents: ["createVenceModal"],
        shouldShowOverlayMask: true,
        sideMenu: "Main",
        mapMarkers: ["venceInclusionPolygon", "venceInclusionRedZonePolygon"],
      },
      9: {
        step: 9,
        overlayElementsId: ["create-vence-button"],
        popoverComponents: ["venceStep2Popover"],
        modalComponents: [],
        shouldShowOverlayMask: true,
        sideMenu: "Main",
        mapMarkers: ["venceInclusionPolygon", "venceInclusionRedZonePolygon"],
      },
      10: {
        step: 10,
        overlayElementsId: ["exclusion-vence-button"],
        popoverComponents: ["venceStep11Popover"],
        modalComponents: [],
        shouldShowOverlayMask: true,
        sideMenu: "CreateVence",
        mapMarkers: ["venceInclusionPolygon", "venceInclusionRedZonePolygon"],
        clearMarkers: ["venceExclusionPolygon"],
      },
      11: {
        step: 11,
        overlayElementsId: ["map-container"],
        popoverComponents: [],
        modalComponents: ["venceStep12Modal"],
        shouldShowOverlayMask: true,
        sideMenu: "CreateVenceConfirm",
        drawingMode: "polygon",
        mapMarkers: [
          "venceInclusionPolygon",
          "venceInclusionRedZonePolygon",
          "venceStep12HighlightedArea",
        ],
        clearMarkers: [],
      },
      // 12: {
      //   step: 12,
      //   overlayElementsId: [],
      //   popoverComponents: [],
      //   modalComponents: [],
      //   shouldShowOverlayMask: false,
      //   sideMenu: "CreateVenceConfirm",
      //   mapMarkers: ["venceInclusionPolygon", "venceInclusionRedZonePolygon"],
      // },
      12: {
        step: 12,
        overlayElementsId: [],
        popoverComponents: ["venceStep6Popover"],
        modalComponents: [],
        shouldShowOverlayMask: false,
        sideMenu: "CreateVenceConfirm",
        mapMarkers: [
          "venceInclusionPolygon",
          "venceInclusionRedZonePolygon",
          "venceStep12HighlightedArea",
          "venceExclusionPolygon",
        ],
        editableMarkers: ["venceExclusionPolygon"],
        clearMarkers: ["venceExclusionRedZonePolygon"],
      },
      13: {
        step: 13,
        overlayElementsId: [],
        popoverComponents: ["venceStep7Popover"],
        modalComponents: ["createVenceModal"],
        shouldShowOverlayMask: false,
        sideMenu: "CreateVenceConfirm",
        mapMarkers: [
          "venceInclusionPolygon",
          "venceInclusionRedZonePolygon",
          "venceExclusionPolygon",
          "venceExclusionRedZonePolygon",
        ],
      },
      14: {
        step: 14,
        overlayElementsId: ["map-container"],
        popoverComponents: [],
        modalComponents: ["venceStep15Modal"],
        shouldShowOverlayMask: true,
        sideMenu: "Main",
        mapMarkers: [
          "venceInclusionPolygon",
          "venceInclusionRedZonePolygon",
          "venceExclusionPolygon",
          "venceExclusionRedZonePolygon",
        ],
        finalStep: true,
      },
    },
    VENCES_ASSIGNING: {
      1: {
        step: 1,
        overlayElementsId: [],
        popoverComponents: [],
        modalComponents: ["venceAssignStep1Modal"],
        shouldShowOverlayMask: false,
        sideMenu: "Main",
        mapMarkers: [],
      },
      2: {
        step: 2,
        overlayElementsId: ["map-container"],
        popoverComponents: [],
        modalComponents: ["venceAssignStep2Modal"],
        shouldShowOverlayMask: true,
        sideMenu: "Main",
        mapMarkers: [],
      },
      3: {
        step: 3,
        overlayElementsId: ["map-container"],
        popoverComponents: [],
        modalComponents: ["venceAssignStep3Modal"],
        shouldShowOverlayMask: true,
        sideMenu: "Main",
        mapMarkers: ["paddockSectionMarkers"],
      },
      4: {
        step: 4,
        overlayElementsId: ["assign-vence-to-herd-button"],
        popoverComponents: ["venceAssignStep4Popover"],
        modalComponents: [],
        clearSameModalComponents: ["assignVenceToHerdModal"],
        shouldShowOverlayMask: true,
        sideMenu: "Main",
        mapMarkers: [],
      },
      5: {
        step: 5,
        overlayElementsId: ["assign-vence-to-herd-modal"],
        popoverComponents: ["venceAssignStep5Popover"],
        modalComponents: [],
        sameModalComponents: ["assignVenceToHerdModal"],
        shouldShowOverlayMask: false,
        sideMenu: "Main",
        currentSection: "Home",
        mapMarkers: [],
      },
      6: {
        step: 6,
        overlayElementsId: ["my-herd-item"],
        popoverComponents: ["venceAssignStep6Popover"],
        modalComponents: [],
        sameModalComponents: ["assignVenceToHerdModal"],
        shouldShowOverlayMask: false,
        sideMenu: "Main",
        currentSection: "SelectHerd",
        mapMarkers: [],
      },
      7: {
        step: 7,
        overlayElementsId: ["footer-controls"],
        popoverComponents: ["venceAssignStep7Popover"],
        modalComponents: [],
        sameModalComponents: ["assignVenceToHerdModal"],
        shouldShowOverlayMask: false,
        sideMenu: "Main",
        currentSection: "SelectHerd",
        highlightSection: ["my-herd-item"],
        mapMarkers: [],
      },
      8: {
        step: 8,
        overlayElementsId: ["assign-vence-to-herd-main-section"],
        popoverComponents: ["venceAssignStep8Popover"],
        modalComponents: [],
        sameModalComponents: ["assignVenceToHerdModal"],
        shouldShowOverlayMask: false,
        sideMenu: "Main",
        currentSection: "VenceAssignmentsForHerd",
        mapMarkers: [],
      },
      9: {
        step: 9,
        overlayElementsId: ["top-of-paddock-item"],
        popoverComponents: ["venceAssignStep9Popover"],
        modalComponents: [],
        sameModalComponents: ["assignVenceToHerdModal"],
        shouldShowOverlayMask: false,
        sideMenu: "Main",
        currentSection: "SelectVence",
        mapMarkers: [],
      },
      10: {
        step: 10,
        overlayElementsId: ["footer-controls"],
        popoverComponents: ["venceAssignStep7Popover"],
        modalComponents: [],
        sameModalComponents: ["assignVenceToHerdModal"],
        shouldShowOverlayMask: false,
        sideMenu: "Main",
        currentSection: "SelectVence",
        highlightSection: ["top-of-paddock-item"],
        selectedVence: "venceDetailsOfTopOfPaddock",
        clearVenceDetails: "venceDetailsOfTopOfPaddock",
        mapMarkers: [],
      },
      11: {
        step: 11,
        overlayElementsId: ["turnON-date-section"],
        popoverComponents: ["venceAssignStep11Popover"],
        modalComponents: [],
        sameModalComponents: ["assignVenceToHerdModal"],
        shouldShowOverlayMask: true,
        sideMenu: "Main",
        currentSection: "OnAndOffDates",
        selectedVence: "venceDetailsOfTopOfPaddock",
        mapMarkers: [],
      },
      12: {
        step: 12,
        overlayElementsId: [
          "assign-vence-to-herd-main-section",
          "assign-vence-to-herd-modal-footer",
        ],
        popoverComponents: ["venceAssignStep12Popover"],
        modalComponents: [],
        sameModalComponents: ["assignVenceToHerdModal"],
        shouldShowOverlayMask: false,
        sideMenu: "Main",
        currentSection: "OnAndOffDates",
        selectedVence: "venceDetailsOfTopOfPaddock",
        mapMarkers: [],
      },
      13: {
        step: 13,
        overlayElementsId: ["assign-vence-to-herd-main-section"],
        popoverComponents: ["venceAssignStep13Popover"],
        modalComponents: [],
        sameModalComponents: ["assignVenceToHerdModal"],
        shouldShowOverlayMask: false,
        sideMenu: "Main",
        currentSection: "VenceAssignmentsForHerdEdit",
        mapMarkers: [],
      },
      14: {
        step: 14,
        overlayElementsId: ["middle-of-paddock-item"],
        popoverComponents: ["venceAssignStep14Popover"],
        modalComponents: [],
        sameModalComponents: ["assignVenceToHerdModal"],
        shouldShowOverlayMask: false,
        sideMenu: "Main",
        currentSection: "SelectVence",
        mapMarkers: [],
      },
      15: {
        step: 15,
        overlayElementsId: ["assign-vence-to-herd-modal-footer"],
        popoverComponents: ["venceAssignStep14Popover"],
        modalComponents: [],
        sameModalComponents: ["assignVenceToHerdModal"],
        shouldShowOverlayMask: false,
        sideMenu: "Main",
        currentSection: "SelectVence",
        highlightSection: ["middle-of-paddock-item"],
        selectedVence: "venceDetailsOfMiddleOfPaddock",
        clearVenceDetails: "venceDetailsOfMiddleOfPaddock",
        mapMarkers: [],
      },
      16: {
        step: 16,
        overlayElementsId: [
          "assign-vence-to-herd-main-section",
          "assign-vence-to-herd-modal-footer",
        ],
        popoverComponents: ["venceAssignStep11Popover"],
        modalComponents: [],
        sameModalComponents: ["assignVenceToHerdModal"],
        shouldShowOverlayMask: false,
        sideMenu: "Main",
        currentSection: "OnAndOffDates",
        selectedVence: "venceDetailsOfMiddleOfPaddock",
        mapMarkers: [],
      },
      17: {
        step: 17,
        overlayElementsId: ["assign-vence-to-herd-main-section"],
        popoverComponents: ["venceAssignStep13Popover"],
        modalComponents: [],
        sameModalComponents: ["assignVenceToHerdModal"],
        shouldShowOverlayMask: false,
        sideMenu: "Main",
        currentSection: "VenceAssignmentsForHerdEdit",
        mapMarkers: [],
      },
      18: {
        step: 18,
        overlayElementsId: ["exclusion-for-lupine-item"],
        popoverComponents: ["venceAssignStep18Popover"],
        modalComponents: [],
        sameModalComponents: ["assignVenceToHerdModal"],
        shouldShowOverlayMask: false,
        sideMenu: "Main",
        currentSection: "SelectVence",
        mapMarkers: [],
      },
      19: {
        step: 19,
        overlayElementsId: ["assign-vence-to-herd-modal-footer"],
        popoverComponents: ["venceAssignStep18Popover"],
        modalComponents: [],
        sameModalComponents: ["assignVenceToHerdModal"],
        shouldShowOverlayMask: false,
        sideMenu: "Main",
        currentSection: "SelectVence",
        highlightSection: ["exclusion-for-lupine-item"],
        selectedVence: "venceDetailsOfExclusionForLupine",
        clearVenceDetails: "venceDetailsOfExclusionForLupine",
        mapMarkers: [],
      },
      20: {
        step: 20,
        overlayElementsId: [
          "assign-vence-to-herd-main-section",
          "assign-vence-to-herd-modal-footer",
        ],
        popoverComponents: [
          "venceAssignStep11Popover",
          "venceAssignStep20Popover",
        ],
        modalComponents: [],
        sameModalComponents: ["assignVenceToHerdModal"],
        shouldShowOverlayMask: false,
        sideMenu: "Main",
        currentSection: "OnAndOffDates",
        selectedVence: "venceDetailsOfExclusionForLupine",
        mapMarkers: [],
      },
      21: {
        step: 21,
        overlayElementsId: [
          "assign-vence-to-herd-main-section",
          "assign-vence-to-herd-modal-footer",
        ],
        popoverComponents: ["venceAssignStep21Popover"],
        modalComponents: [],
        sameModalComponents: ["assignVenceToHerdModal"],
        shouldShowOverlayMask: false,
        sideMenu: "Main",
        currentSection: "VenceAssignmentsForHerdEdit",
        mapMarkers: [],
      },
      22: {
        step: 22,
        overlayElementsId: ["map-container"],
        popoverComponents: [],
        modalComponents: ["venceAssignStep22Modal"],
        clearSameModalComponents: ["assignVenceToHerdModal"],
        shouldShowOverlayMask: true,
        sideMenu: "Main",
        mapMarkers: [],
      },
      23: {
        step: 23,
        overlayElementsId: [],
        popoverComponents: [],
        modalComponents: ["venceAssignStep23Modal"],
        shouldShowOverlayMask: false,
        sideMenu: "Main",
        mapMarkers: [],
        finalStep: true,
      },
    },
  };

  useEffect(() => {
    const { tutorialId } = params;
    let tutorial = "";
    if (tutorialId === "setting-landmark") {
      tutorial = "LANDMARKS_SETTING_UP";
    } else if (tutorialId === "setting-herd") {
      tutorial = "HERDS_SETTING_UP";
    } else if (tutorialId === "creating-vence") {
      tutorial = "VENCES_CREATING";
    } else if (tutorialId === "assigning-vence") {
      tutorial = "VENCES_ASSIGNING";
    } else {
      tutorial = "LANDMARKS_SETTING_UP";
    }
    setCurrentTutorial(tutorial);
    setCurrentTutorialId(tutorialId);
  }, [params]);

  const functionsWithRefs = {
    landmarkSettingUpTutorialModal: setLandmarkSettingUpTutorialModal,
    landmarkStep2Modal: setLandmarkStep2Modal,
    landmarkStep5Modal: setLandmarkStep5Modal,
    landmarkStep8Modal: setLandmarkStep8Modal,
    landmarkStep11Modal: setLandmarkStep11Modal,
    landmarkStep13Modal: setLandmarkStep13Modal,
    landmarkStep15Modal: setLandmarkStep15Modal,

    herdStep1Modal: setHerdStep1Modal,
    herdStep2Modal: setHerdStep2Modal,
    herdStep3Modal: setHerdStep3Modal,
    herdStep6Modal: setHerdStep6Modal,
    herdStep8Modal: setHerdStep8Modal,
    herdStep11Modal: setHerdStep11Modal,
    herdStep12Modal: setHerdStep12Modal,

    venceStep1Modal: setVenceStep1Modal,
    venceStep4Modal: setVenceStep4Modal,
    venceStep9Modal: setVenceStep9Modal,
    venceStep12Modal: setVenceStep12Modal,
    venceStep15Modal: setVenceStep15Modal,

    venceAssignStep1Modal: setVenceAssignStep1Modal,
    venceAssignStep2Modal: setVenceAssignStep2Modal,
    venceAssignStep3Modal: setVenceAssignStep3Modal,
    assignVenceToHerdModal: setAssignVenceToHerdModal,
    venceAssignStep22Modal: setVenceAssignStep22Modal,
    venceAssignStep23Modal: setVenceAssignStep23Modal,
  };

  useEffect(() => {
    if (currentTutorial === "" || currentStep === "") return;
    const stepDetails = tutorialsDetails[currentTutorial][currentStep];
    setCurrentStepDetails(stepDetails);
    stepDetails.modalComponents?.forEach((modalComponent) => {
      functionsWithRefs[modalComponent] &&
        functionsWithRefs[modalComponent](true);
    });

    stepDetails.popoverComponents?.forEach((popoverComponent) => {
      functionsWithRefs[popoverComponent] &&
        functionsWithRefs[popoverComponent](true);
    });

    stepDetails.sameModalComponents?.forEach((modalComponent) => {
      functionsWithRefs[modalComponent] &&
        functionsWithRefs[modalComponent](true);
    });
    stepDetails.clearSameModalComponents?.forEach((modalComponent) => {
      functionsWithRefs[modalComponent] &&
        functionsWithRefs[modalComponent](false);
    });

    return () => {
      stepDetails.modalComponents?.forEach((modalComponent) => {
        functionsWithRefs[modalComponent] &&
          functionsWithRefs[modalComponent](false);
      });

      stepDetails.popoverComponents?.forEach((popoverComponent) => {
        functionsWithRefs[popoverComponent] &&
          functionsWithRefs[popoverComponent](false);
      });
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentStep, currentTutorial]);

  useEffect(() => {
    if (currentStepDetails.step === 1) {
      setStartTimeOfTutorial(new Date().toISOString());
      ReactGA.event({
        category: "engagement",
        action: "Started",
        label: currentTutorialId,
      })
    }
    if (currentStepDetails.finalStep && startTimeOfTutorial) {
      let endTimeOfTutorial = new Date().toISOString();
      let timeTaken = new Date(endTimeOfTutorial).getTime() - new Date(startTimeOfTutorial).getTime();
      ReactGA.event({
        category: "engagement",
        action: "Completed",
        label: currentTutorialId,
        value: timeTaken/1000,
      })
      setStartTimeOfTutorial(null);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentStepDetails.step]);

  const toggleCollapse = () => {
    setCollapsed(!collapsed);
  };

  const togglePlayVideo = () => {
    if (videoRef.current.paused) {
      videoRef.current.play();
      setShowPlayVideoButton(false);
    } else {
      videoRef.current.pause();
      setShowPlayVideoButton(true);
    }
  };

  const contentOfCollaringVideo = (
    <div>
      <p>
        First off, you’ll need to have your animals collared with the Vence
        Cattle Rider™ collars. Hit <strong>Play Video</strong> for a quick demo
        of how to collar.
      </p>
      <div>
        <Button
          type="primary"
          size="middle"
          style={{ left: "60%" }}
          onClick={() => setCurrentStep((step) => step + 1)}
          className="tutorial-guide-button"
        >
          Skip Video
        </Button>
      </div>
    </div>
  );

  const onExit = () => {
    ReactGA.event({
      category: "engagement",
      action: "Exited",
      label: currentTutorialId,
    })
    window.close();
  }

  return (
    <div className="management-container">
      <div
        id="overlay-mask"
        className={clsx({
          "ant-modal-mask": currentStepDetails.shouldShowOverlayMask,
        })}
      />
      <Layout>
        <Header className="header-container">
          <NavBar collapsed={collapsed} toggleCollapse={toggleCollapse} />
        </Header>
        <Layout>
          <Content>
            <div
              style={{ height: "calc(100vh - 56px)", width: "100%" }}
              className={clsx("map-container", {
                "overlay-element-active":
                  currentStepDetails.overlayElementsId?.includes(
                    "map-container"
                  ),
              })}
              id="map-container"
            >
              <Map
                landmark={landmark}
                currentTutorial={currentTutorial}
                currentStepDetails={currentStepDetails}
                setHerdMarkerDetails={setHerdMarkerDetails}
                setCurrentStep={setCurrentStep}
                setVenceInclusionDetails={setVenceInclusionDetails}
                setVenceExclusionDetails={setVenceExclusionDetails}
              />
            </div>
          </Content>
          <Sider
            theme="light"
            trigger={null}
            collapsible
            collapsed={collapsed}
            collapsedWidth={0}
            zeroWidthTriggerStyle={{ display: "none" }}
            width="25vw"
            className={clsx({
              "overlay-element-active":
                currentStepDetails.overlayElementsId?.includes(
                  "sidebar-container"
                ),
            })}
            id="sidebar-container"
          >
            <SideBar
              setLandmark={setLandmark}
              landmark={landmark}
              currentStepDetails={currentStepDetails}
              setCurrentStep={setCurrentStep}
              setHerdMarkerDetails={setHerdMarkerDetails}
              herdMarkerDetails={herdMarkerDetails}
              venceInclusionDetails={venceInclusionDetails}
              venceExclusionDetails={venceExclusionDetails}
            />
          </Sider>
        </Layout>
      </Layout>
      <div className="tutorial-control-buttons">
        <Button onClick={() => onExit()}>Exit tutorial</Button>
        <Button
          style={{ marginLeft: "15px" }}
          onClick={() => setCurrentStep((step) => step - 1)}
          disabled={currentStep === 1}
        >
          Previous step
        </Button>
      </div>
      <Modal
        visible={landmarkSettingUpTutorialModal}
        width={300}
        title={PopoverTitle}
        footer={null}
        closable={false}
        centered
        className="tutorial-guide-modal"
      >
        <div>
          <p>Welcome to Herd Manager!</p>
          <p>
            This tutorial will help you learn how to set up the basic parts of
            your ranch.
          </p>
          <div>
            <Button
              type="primary"
              size="middle"
              style={{ left: "80%" }}
              onClick={() => setCurrentStep((step) => step + 1)}
              className="tutorial-guide-button"
            >
              Next
            </Button>
          </div>
        </div>
      </Modal>
      <Modal
        visible={landmarkStep2Modal}
        width={300}
        title={PopoverTitle}
        footer={null}
        closable={false}
        style={{ top: "30%", left: "10%" }}
        //This class is used to remove the mask of the modal and allow the user to access the background.
        wrapClassName="tutorial-guide-modal-wrap"
        className="tutorial-guide-modal"
        mask={false}
      >
        <div>
          <p>
            This is a <strong>paddock.</strong> Paddocks are permanently fenced
            areas that define your ranch. Let’s add a second one to this ranch.
          </p>
          <div>
            <Button
              type="primary"
              size="middle"
              style={{ left: "80%" }}
              onClick={() => setCurrentStep((step) => step + 1)}
              className="tutorial-guide-button"
            >
              Next
            </Button>
          </div>
        </div>
      </Modal>
      <Modal
        visible={landmarkStep5Modal}
        width={300}
        title={PopoverTitle}
        footer={null}
        closable={false}
        style={{ top: "20%", left: "5%" }}
        wrapClassName="tutorial-guide-modal-wrap"
        className="tutorial-guide-modal"
        mask={false}
      >
        <div>
          <p>
            Draw a paddock wherever you’d like to make it. When you’re satisfied
            with it, click <strong>SAVE</strong> on the upper right.
          </p>
        </div>
      </Modal>
      <Modal
        visible={landmarkStep8Modal}
        width={300}
        title={PopoverTitle}
        footer={null}
        closable={false}
        style={{ top: "20%", left: "5%" }}
        wrapClassName="tutorial-guide-modal-wrap"
        className="tutorial-guide-modal"
        mask={false}
      >
        <div>
          <p>Excellent! You’ve drawn your first paddock!</p>
          <p>
            Now let’s try adding a <strong>Gateway</strong> landmark.
          </p>
          <div>
            <Button
              type="primary"
              size="middle"
              style={{ left: "80%" }}
              onClick={() => setCurrentStep((step) => step + 1)}
              className="tutorial-guide-button"
            >
              Next
            </Button>
          </div>
        </div>
      </Modal>
      <Modal
        visible={landmarkStep11Modal}
        width={300}
        title={PopoverTitle}
        footer={null}
        closable={false}
        style={{ top: "20%", left: "5%" }}
        wrapClassName="tutorial-guide-modal-wrap"
        className="tutorial-guide-modal"
        mask={false}
      >
        <div>
          <p>
            Click the map anywhere to create a point landmark. When you’re happy
            with the placement, click <strong>SAVE</strong> in the upper right.
          </p>
        </div>
      </Modal>
      <Modal
        visible={landmarkStep13Modal}
        width={300}
        title={PopoverTitle}
        footer={null}
        closable={false}
        style={{ top: "20%", left: "5%" }}
        wrapClassName="tutorial-guide-modal-wrap"
        className="tutorial-guide-modal"
        mask={false}
      >
        <div>
          <p>Great! You’ve set up a Gateway.</p>
          <div>
            <Button
              type="primary"
              size="middle"
              style={{ left: "80%" }}
              onClick={() => setCurrentStep((step) => step + 1)}
              className="tutorial-guide-button"
            >
              Next
            </Button>
          </div>
        </div>
      </Modal>
      <Modal
        visible={landmarkStep15Modal}
        width={300}
        title={PopoverTitle}
        footer={null}
        closable={false}
        centered
        className="tutorial-guide-modal"
      >
        <div>
          <p>Congratulations! You’ve completed the Landmarks tutorial.</p>
          <div>
            <Button
              type="primary"
              size="middle"
              style={{ left: "60%" }}
              onClick={() => onExit()}
              className="tutorial-guide-button"
            >
              Exit tutorial
            </Button>
          </div>
        </div>
      </Modal>

      <Modal
        visible={herdStep1Modal}
        width={300}
        title={PopoverTitle}
        footer={null}
        closable={false}
        centered
        className="tutorial-guide-modal"
      >
        <div>
          <p>
            Welcome to the <strong>Setting Up Herds</strong> tutorial!
          </p>
          <p>
            I’ll be showing you how to create a herd and add your animal
            inventory to it.
          </p>
          <div>
            <Button
              type="primary"
              size="middle"
              style={{ left: "80%" }}
              onClick={() => setCurrentStep((step) => step + 1)}
              className="tutorial-guide-button"
            >
              Next
            </Button>
          </div>
        </div>
      </Modal>
      <Modal
        visible={herdStep2Modal}
        closable={false}
        footer={null}
        width={704}
        className="tutorial-video-modal"
        style={{ top: "20%", left: "5%" }}
        destroyOnClose={true}
      >
        <Popover
          title={PopoverTitle}
          content={contentOfCollaringVideo}
          placement="left"
          trigger="hover"
          visible={herdStep2Modal}
        >
          <video
            ref={videoRef}
            id="collaring-video"
            controls
            controlsList="nodownload nofullscreen noremoteplayback noplaybackrate"
            disablePictureInPicture
          >
            <source src={CollaringVideo} type="video/mp4" />
          </video>
        </Popover>
        {/* {showPlayVideoButton ? (
          <Button className="play-button" onClick={togglePlayVideo}>
            PLAY VIDEO (1 min)
          </Button>
        ) : (
          <PauseOutlined onClick={togglePlayVideo} className="pause-button" />
        )} */}
      </Modal>
      <Modal
        visible={herdStep3Modal}
        width={300}
        title={PopoverTitle}
        footer={null}
        closable={false}
        style={{ top: "30%", left: "10%" }}
        wrapClassName="tutorial-guide-modal-wrap"
        className="tutorial-guide-modal"
        mask={false}
      >
        <div>
          <p>
            For the purposes of this tutorial, let’s assume that this is a{" "}
            <strong>paddock</strong> on your operation and the little icons are
            the <strong>animals you’ve just collared.</strong>
          </p>
          <p>We need to put these animals into a herd.</p>
          <div>
            <Button
              type="primary"
              size="middle"
              style={{ left: "80%" }}
              onClick={() => setCurrentStep((step) => step + 1)}
              className="tutorial-guide-button"
            >
              Next
            </Button>
          </div>
        </div>
      </Modal>
      <Modal
        visible={herdStep6Modal}
        width={300}
        title={PopoverTitle}
        footer={null}
        closable={false}
        style={{ top: "20%", left: "5%" }}
        wrapClassName="tutorial-guide-modal-wrap"
        className="tutorial-guide-modal"
        mask={false}
      >
        <div>
          <p>
            <strong>Draw a rectangle</strong> around the collars you want to use
            to create your new herd.
          </p>
          <p>
            When you’re satisfied with it, click <strong>CREATE HERD</strong> on
            the upper right.
          </p>
        </div>
      </Modal>
      <Modal
        visible={herdStep8Modal}
        width={300}
        title={PopoverTitle}
        footer={null}
        closable={false}
        style={{ top: "30%", left: "10%" }}
        wrapClassName="tutorial-guide-modal-wrap"
        className="tutorial-guide-modal"
        mask={false}
      >
        <div>
          <p>
            Your new herd will appear on the map as a green marker with the
            number of animals currently in that herd.
          </p>
          <div>
            <Button
              type="primary"
              size="middle"
              style={{ left: "80%" }}
              onClick={() => setCurrentStep((step) => step + 1)}
              className="tutorial-guide-button"
            >
              Next
            </Button>
          </div>
        </div>
      </Modal>
      <Modal
        visible={herdStep11Modal}
        width={300}
        title={PopoverTitle}
        footer={null}
        closable={false}
        style={{ top: "20%", left: "5%" }}
        wrapClassName="tutorial-guide-modal-wrap"
        className="tutorial-guide-modal"
        mask={false}
      >
        <div>
          <p>You can now see the individual animals in your new herd.</p>
          <div>
            <Button
              type="primary"
              size="middle"
              style={{ left: "80%" }}
              onClick={() => setCurrentStep((step) => step + 1)}
              className="tutorial-guide-button"
            >
              Next
            </Button>
          </div>
        </div>
      </Modal>
      <Modal
        visible={herdStep12Modal}
        width={300}
        title={PopoverTitle}
        footer={null}
        closable={false}
        centered
        className="tutorial-guide-modal"
      >
        <div>
          <p>
            Congratulations! You’ve completed the{" "}
            <strong>Setting Up Herds</strong> tutorial!
          </p>
          <div>
            <Button
              type="primary"
              size="middle"
              style={{ left: "60%" }}
              onClick={() => onExit()}
              className="tutorial-guide-button"
            >
              Exit tutorial
            </Button>
          </div>
        </div>
      </Modal>

      <Modal
        visible={venceStep1Modal}
        width={300}
        title={PopoverTitle}
        footer={null}
        closable={false}
        centered
        className="tutorial-guide-modal"
      >
        <div>
          <p>
            Welcome to the <strong>Setting Up Vences</strong> tutorial!
          </p>
          <p>
            The first thing we want to do is to learn{" "}
            <strong>how to draw vences</strong>. It’s similar to drawing a
            pasture but with a couple key differences.
          </p>
          <div>
            <Button
              type="primary"
              size="middle"
              style={{ left: "80%" }}
              onClick={() => setCurrentStep((step) => step + 1)}
              className="tutorial-guide-button"
            >
              Next
            </Button>
          </div>
        </div>
      </Modal>
      <Modal
        visible={venceStep4Modal}
        width={300}
        title={PopoverTitle}
        footer={null}
        closable={false}
        style={{ top: "20%", left: "5%" }}
        wrapClassName="tutorial-guide-modal-wrap"
        className="tutorial-guide-modal"
        mask={false}
      >
        <div>
          <p>
            We’ll use vences to subdivide this pasture into three sections.{" "}
            <b>Use your cursor to draw vence lines</b> in the general
            highlighted area. This will be the area we want the cattle to stay
            in.
          </p>
          <p>
            Note:{" "}
            <b>
              vence lines must be drawn past the edges of the permanent fencing
            </b>
            . This helps ensure you don’t have escapees if the GPS isn’t
            perfectly accurate.
          </p>
        </div>
      </Modal>
      <Modal
        visible={venceStep9Modal}
        width={300}
        title={PopoverTitle}
        footer={null}
        closable={false}
        style={{ top: "20%", left: "3%" }}
        wrapClassName="tutorial-guide-modal-wrap"
        className="tutorial-guide-modal"
        mask={false}
      >
        <div>
          <p>
            Nice work! You’ve drawn a vence but that vence won’t be active until
            we assign it to a herd later.
          </p>
          <p>
            For now, we’ll learn how to create an exclusion area in this
            pasture.
          </p>
          <div>
            <Button
              type="primary"
              size="middle"
              style={{ left: "80%" }}
              onClick={() => setCurrentStep((step) => step + 1)}
              className="tutorial-guide-button"
            >
              Next
            </Button>
          </div>
        </div>
      </Modal>
      <Modal
        visible={venceStep12Modal}
        width={300}
        title={PopoverTitle}
        footer={null}
        closable={false}
        style={{ top: "20%", left: "3%" }}
        wrapClassName="tutorial-guide-modal-wrap"
        className="tutorial-guide-modal"
        mask={false}
      >
        <div>
          <p>
            We’d like to vence off area where lupine is growing. It’s toxic to
            cattle so we don’t want them getting into it, if possible.
          </p>
          <p>
            <strong>Draw a vence line,</strong> tracing the yellow highlighted
            area.
          </p>
        </div>
      </Modal>
      <Modal
        visible={venceStep15Modal}
        width={300}
        title={PopoverTitle}
        footer={null}
        closable={false}
        centered
        style={{ top: "20%", left: "50%" }}
        wrapClassName="tutorial-guide-modal-wrap"
        className="tutorial-guide-modal"
        mask={false}
      >
        <div>
          <p>
            Great! This exclusion vence should do a good job of keeping the
            cattle out of this area.
          </p>
          <p>
            Keep in mind that you’ve created these vences but haven’t activated
            them yet. We’ll cover how you turn vences on and off in the next
            tutorial, <strong>Assigning Vences to Herds.</strong>
          </p>
          <div>
            <Button
              type="primary"
              size="middle"
              style={{ left: "60%" }}
              onClick={() => onExit()}
              className="tutorial-guide-button"
            >
              Exit tutorial
            </Button>
          </div>
        </div>
      </Modal>

      <Modal
        visible={venceAssignStep1Modal}
        width={300}
        title={PopoverTitle}
        footer={null}
        closable={false}
        centered
        className="tutorial-guide-modal"
      >
        <div>
          <p>
            Welcome to the <strong>Assigning Vences to Herds</strong> tutorial!
          </p>
          <p>
            It may seem counter-intuitive, but in Herd Manager{" "}
            <strong>
              you’ll be assigning vences to herds, not assigning herds to
              vences.
            </strong>
          </p>
          <div>
            <Button
              type="primary"
              size="middle"
              style={{ left: "80%" }}
              onClick={() => setCurrentStep((step) => step + 1)}
              className="tutorial-guide-button"
            >
              Next
            </Button>
          </div>
        </div>
      </Modal>
      <Modal
        visible={venceAssignStep2Modal}
        width={300}
        title={PopoverTitle}
        footer={null}
        closable={false}
        style={{ top: "20%", left: "3%" }}
        wrapClassName="tutorial-guide-modal-wrap"
        className="tutorial-guide-modal"
        mask={false}
      >
        <div>
          <p>We’ve gone ahead and added 3 vences to this paddock:</p>
          <ul
            className="tutorial-guide-list-item"
            style={{ paddingInlineStart: "20px" }}
          >
            <li>an inclusion for the top of the pasture</li>
            <li>an inclusion for the middle of the pasture</li>
            <li>
              and an exclusion for the eastern side to keep the cattle out of
              some lupine.
            </li>
          </ul>

          <p>
            Our herd is already in this pasture, represented by the{" "}
            <img src={HerdWith10Icon} alt="Herd with 10 Cattle" />
          </p>
          <div>
            <Button
              type="primary"
              size="middle"
              style={{ left: "80%" }}
              onClick={() => setCurrentStep((step) => step + 1)}
              className="tutorial-guide-button"
            >
              Next
            </Button>
          </div>
        </div>
      </Modal>
      <Modal
        visible={venceAssignStep3Modal}
        width={300}
        title={PopoverTitle}
        footer={null}
        closable={false}
        style={{ top: "20%", left: "3%" }}
        wrapClassName="tutorial-guide-modal-wrap"
        className="tutorial-guide-modal"
        mask={false}
      >
        <div>
          <p>We want our herd to:</p>
          <ol
            className="tutorial-guide-list-item number-list-custom"
            style={{ paddingInlineStart: "5px" }}
          >
            <li>stay in the top part of the paddock and graze for 3 days</li>
            <li>move to the middle paddock and graze for 3 days</li>
            <li>move to the bottom of the paddock.</li>
          </ol>

          <p>
            But the entire time we also want them to stay out of the lupine in
            the exclusion.
          </p>
          <div>
            <Button
              type="primary"
              size="middle"
              style={{ left: "80%" }}
              onClick={() => setCurrentStep((step) => step + 1)}
              className="tutorial-guide-button"
            >
              Next
            </Button>
          </div>
        </div>
      </Modal>
      <VencesAssigning
        assignVenceToHerdModal={assignVenceToHerdModal}
        setCurrentStep={setCurrentStep}
        currentStepDetails={currentStepDetails}
      />
      <Modal
        visible={venceAssignStep22Modal}
        width={300}
        title={PopoverTitle}
        footer={null}
        closable={false}
        style={{ top: "20%", left: "3%" }}
        wrapClassName="tutorial-guide-modal-wrap"
        className="tutorial-guide-modal"
        mask={false}
      >
        <div>
          <p>
            My Herd’s collars are now being sent the new vence assignments.{" "}
            <b>
              {" "}
              The herd icon is now red because the collars have not been updated
              yet.
            </b>{" "}
            It takes some time (usually a couple hours) to talk to all the
            collars and make sure they all have the new vence assignments.
          </p>
          <ul
            className="tutorial-guide-list-item"
            style={{ paddingInlineStart: "20px" }}
          >
            <li>
              <span style={{ color: "#FFC107" }}>Yellow</span> : 0–75% have
              been updated
            </li>
            <li>
              <span style={{ color: "green" }}>Green</span> : 75%+ have been
              updated
            </li>
          </ul>
          <div>
            <Button
              type="primary"
              size="middle"
              style={{ left: "80%" }}
              onClick={() => setCurrentStep((step) => step + 1)}
              className="tutorial-guide-button"
            >
              Next
            </Button>
          </div>
        </div>
      </Modal>
      <Modal
        visible={venceAssignStep23Modal}
        width={300}
        title={PopoverTitle}
        footer={null}
        closable={false}
        centered
        className="tutorial-guide-modal"
      >
        <div>
          <p>
            Congratulations! You’ve completed the Assigning Vences to Herds
            tutorial!
          </p>
          <p>I know that was a long one, so thanks for sticking in there.</p>
          <div>
            <Button
              type="primary"
              size="middle"
              style={{ left: "60%" }}
              onClick={() => onExit()}
              className="tutorial-guide-button"
            >
              Exit tutorial
            </Button>
          </div>
        </div>
      </Modal>
    </div>
  );
}

export default Management;
